import React from 'react'

const MessageWall = () => {
  return <div>contact</div>
}

export default MessageWall



// WEBPACK FOOTER //
// ./src/components/Wall/MessageWall.js